import type { Resource } from './Resource'

export interface RequestInit {
    status: 'init'
}
export interface RequestSubmitted {
    status: 'submitted'
}
export interface RequestFullfilled<T> {
    status: 'fulfilled'
    statusCode: number
    data: T
}
export interface RequestRejected<T> {
    status: 'rejected'
    statusCode: number
    data: T
}
export interface RequestFailed<T> {
    status: 'fail'
    statusCode: number
    data: T
}

export type Request<D, RejectionError = any, FailureError = any> =
    | RequestInit
    | RequestSubmitted
    | RequestFullfilled<D>
    | RequestRejected<RejectionError>
    | RequestFailed<FailureError>

export const translateToResource = <D>(request: Request<D>): Resource<D> => {
    switch (request.status) {
        case 'init':
            return {
                status: 'init',
            }
        case 'submitted':
            return {
                status: 'submitted',
            }
        case 'fulfilled':
            return {
                status: 'fulfilled',
                data: request.data,
            }
        case 'rejected':
            return {
                status: 'rejected',
                data: request.data,
            }
        case 'fail':
            return {
                status: 'fail',
                data: request.data,
            }
    }
}
